
import {Vue, Component} from 'vue-property-decorator';
import {mechanismApi} from "@/api/organization";
import ckeditor4 from "@/components/CkeditorComponent.vue";
import SelectMechanism from "@/components/SelectMechanism.vue";
import baseUrl, {imageUrl} from "@/constants";
import {ref, reactive, defineAsyncComponent} from "vue";
import {Message} from "element-ui";

const {regionData, CodeToText} = require("@/js/region/region");

@Component({
  components: {
    ckeditor4,SelectMechanism
  }
})
export default class YearConfirmList extends Vue {
  private organizations = [];// 企业列表
  private showQuery = false;
  private regionData = regionData;
  private loading = false;
  private CodeToText = CodeToText;
  private infoId = 0;
  private showInfo = false;
  form_data = {};
  private queryParams = {
    name: '',
    area: '',
    status: 1,
    current: 1,
    size: 10,
    total: 0
  }
  getInfoData(){
    mechanismApi.getMechanismAndUser(this.infoId).then((res:any) => {
      this.form_data = res.data.data;
    }).catch((err:any)=>{
      Message.error(err.msg);
    });
  }
  imageUrl() {
    return imageUrl
  }

  baseUrl() {
    return baseUrl;
  }

  mounted() {
    // 加载企业列表
    this.loadData();
  }

  loadData(){
    this.showQuery = false;
    this.loading = true;
    mechanismApi.list(this.queryParams).then((r: any) => {
      this.loading = false;
      if (r.data.result === 0) {
        const rData = r.data.data.records;
        this.queryParams.total = r.data.data.total;
        this.organizations = rData;
      }
    }).catch(() => {
      this.loading = false;
    })
  }

  showDetail(){
    if(this.isCheckedOne()){
      // TODO 显示企业信息弹框
      this.infoId = this.selectedItems[0]['id'];
      this.showInfo = true;
      this.getInfoData();
    }
  }

  isCheckedOne(){
    if(this.isChecked()){
      if(this.selectedItems.length !== 1){
        this.$message.error("请先选择一条记录");
        return false;
      }
    }

    return true;
  }

  isChecked(){
    if(!this.selectedItems || this.selectedItems.length === 0){
      this.$message.error("请先选择一条记录");
      return false;
    }

    return true;
  }

  private selectedItems = [];
  onSelectItem(selection: any, row: any) {
    this.selectedItems = selection;
  }
  pageSizeChange(val: number) {
    this.queryParams.size = val;
    this.loadData();
  }
  pageCurrentChange(val: number) {
    this.queryParams.current = val;
    this.loadData();
  }
  indexMethod(index: any) {
    return (this.queryParams.current-1)*this.queryParams.size+index+1;
  }
}
